// import React from 'react';
// import Accordion, { AccordionItem, AccordionTitle, AccordionContent } from "../Accordion";

// const AccordionWrap = () => {
//     return (
//         <div className="agency-accordion max-mb-n30">
//             <Accordion>
//                 <AccordionItem id="one">
//                     <AccordionTitle id="one">What exactly is branding?</AccordionTitle>
//                     <AccordionContent id="one">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
//                 </AccordionItem>
//                 <AccordionItem id="two">
//                     <AccordionTitle id="two">What’s the branding process like?</AccordionTitle>
//                     <AccordionContent id="two">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
//                 </AccordionItem>
//                 <AccordionItem id="three">
//                     <AccordionTitle id="three">What type of creative services do you offer?</AccordionTitle>
//                     <AccordionContent id="three">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
//                 </AccordionItem>
//                 <AccordionItem id="three">
//                     <AccordionTitle id="three">What type of creative services do you offer?</AccordionTitle>
//                     <AccordionContent id="three">Branding is more than a logo and a clever tagline. Your brand tells the story of your company. It’s your message and your values. When that happens, remarkable things occur.</AccordionContent>
//                 </AccordionItem>
//             </Accordion>
//         </div>
//     )
// }

// export default AccordionWrap;

// import React from "react";
// import Accordion, {
//   AccordionItem,
//   AccordionTitle,
//   AccordionContent,
// } from "../Accordion";

// const AccordionWrap = ({onSelect}) => {
//   return (
//     <div className="agency-accordion max-mb-n30"  >
//       <Accordion>
//         {/* Engagement 1 */}
//         <AccordionItem id="eng1">
//           <AccordionTitle id="eng1"  onClick={() => onSelect(0)}>
//             Independent Technical Due Diligence for Operating Wind Assets
//           </AccordionTitle>
//           <AccordionContent id="eng1" >
//             <p><strong>Location:</strong> Gujarat</p>
//             <p><strong>Client Type:</strong> Indian IPP / Sponsor-backed platform</p>
//             <p><strong>Portfolio:</strong> ~65 MW operating wind assets (32 WTGs)</p>
//             <p><strong>Role:</strong> Independent Technical Advisor / TDD Consultant</p>

//             <p><strong>Scope:</strong></p>
//             <ul>
//               <li>Finance-grade resource & energy yield assessment (WRF–CFD, P50/P75/P90)</li>
//               <li>SCADA & generation reconciliation and OEYA-style analysis</li>
//               <li>Technical condition screening, grid evacuation review, ROM CAPEX</li>
//               <li>Identification of red flags and WTGs for site verification</li>
//             </ul>

//             <p><strong>Outcome:</strong></p>
//             <ul>
//               <li>Lender-ready TDD / TEV report</li>
//               <li>Energy yield sensitivities and risk register</li>
//               <li>Inputs used for investment and refinancing evaluation</li>
//             </ul>
//           </AccordionContent>
//         </AccordionItem>

//         {/* Engagement 2 */}
//         <AccordionItem id="eng2">
//           <AccordionTitle id="eng2"  onClick={() => onSelect(1)}>
//             Multi-Site Wind Portfolio Techno-Economic & Performance Due Diligence
//           </AccordionTitle>
//           <AccordionContent id="eng2">
//             <p><strong>Location:</strong> Rajasthan, Maharashtra, Madhya Pradesh</p>
//             <p><strong>Client Type:</strong> Large Indian wind platform (OEM-linked)</p>
//             <p><strong>Portfolio:</strong> ~120 MW across multiple states</p>
//             <p><strong>Role:</strong> Independent Technical & Performance Advisor</p>

//             <p><strong>Scope:</strong></p>
//             <ul>
//               <li>Portfolio-level EYA & OEYA (desktop-based)</li>
//               <li>Long-term normalization using reanalysis datasets</li>
//               <li>Operational benchmarking across sites and turbine models</li>
//               <li>Grid interface overview and restoration CAPEX estimation</li>
//             </ul>

//             <p><strong>Outcome:</strong></p>
//             <ul>
//               <li>Consolidated P75/P90 portfolio metrics</li>
//               <li>Identification of underperforming sites and reliability risks</li>
//               <li>Investment prioritization and refurbishment roadmap</li>
//             </ul>
//           </AccordionContent>
//         </AccordionItem>

//         {/* Engagement 3 */}
//         <AccordionItem id="eng3">
//           <AccordionTitle id="eng3"  onClick={() => onSelect(2)}>
//             Lender-Support Technical Review for Operating Wind Assets
//           </AccordionTitle>
//           <AccordionContent id="eng3">
//             <p><strong>Location:</strong> Multi-site, India</p>
//             <p><strong>Client Type:</strong> Domestic lender / credit committee</p>
//             <p><strong>Portfolio:</strong> Operating wind assets</p>
//             <p><strong>Role:</strong> Independent Engineer-style Technical Reviewer</p>

//             <p><strong>Scope:</strong></p>
//             <ul>
//               <li>Document & VDR review (SCADA, O&M, grid, warranties)</li>
//               <li>Validation of sponsor energy assumptions and downside cases</li>
//               <li>Technical risk register and mitigation framework</li>
//               <li>Management and lender Q&A support</li>
//             </ul>

//             <p><strong>Outcome:</strong></p>
//             <ul>
//               <li>Finance-grade technical memo and draft/final reports</li>
//               <li>Support to lender credit approval and conditions precedent</li>
//             </ul>
//           </AccordionContent>
//         </AccordionItem>
//       </Accordion>
//     </div>
//   );
// };

// export default AccordionWrap;


import React from "react";
import Accordion, {
  AccordionItem,
  AccordionTitle,
  AccordionContent,
} from "../Accordion";

const AccordionWrap = ({ onSelect }) => {
  return (
    <div className="agency-accordion max-mb-n30">
      <Accordion>

        {/* Engagement 5 (NOW FIRST) */}
        <AccordionItem id="eng5">
          <span
            onClick={() => onSelect(0)}
            style={{ display: "block", cursor: "pointer" }}
          >
            <AccordionTitle id="eng5">
              International OEPA for Operating Wind & Solar Assets
            </AccordionTitle>
          </span>

          <AccordionContent id="eng5">
            <p><strong>Location:</strong> International</p>
            <p>
              <strong>Client Type:</strong> International renewable energy
              platform / infrastructure fund
            </p>
            <p>
              <strong>Portfolio:</strong> Operating wind and solar assets across
              multiple regulatory and climatic regimes
            </p>
            <p>
              <strong>Role:</strong> Independent Operational Energy Performance
              Advisor
            </p>

            <p><strong>Scope:</strong></p>
            <ul>
              <li>
                Operational Energy Performance Assessment (OEPA) across diverse
                asset classes
              </li>
              <li>
                SCADA-based performance benchmarking against long-term energy
                expectations
              </li>
              <li>
                Normalization for inter-annual variability using global
                reanalysis datasets
              </li>
              <li>
                Loss attribution covering availability, curtailment, wake, and
                grid impacts
              </li>
              <li>
                Cross-market comparison of asset performance and operational
                practices
              </li>
            </ul>

            <p><strong>Outcome:</strong></p>
            <ul>
              <li>
                Asset-level and portfolio-level OEPA reports for investment
                oversight
              </li>
              <li>
                Identification of systemic underperformance and recoverable
                energy losses
              </li>
              <li>
                Actionable recommendations for O&M optimization and value
                enhancement
              </li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        {/* Engagement 2 (NOW SECOND) */}
        <AccordionItem id="eng2">
          <span
            onClick={() => onSelect(1)}
            style={{ display: "block", cursor: "pointer" }}
          >
            <AccordionTitle id="eng2">
              Multi-Site Wind Portfolio Techno-Economic & Performance Due
              Diligence
            </AccordionTitle>
          </span>

          <AccordionContent id="eng2">
            <p><strong>Location:</strong> Rajasthan, Maharashtra, Madhya Pradesh</p>
            <p>
              <strong>Client Type:</strong> Large Indian wind platform
              (OEM-linked)
            </p>
            <p><strong>Portfolio:</strong> ~120 MW across multiple states</p>
            <p>
              <strong>Role:</strong> Independent Technical & Performance Advisor
            </p>

            <p><strong>Scope:</strong></p>
            <ul>
              <li>Portfolio-level EYA & OEYA (desktop-based)</li>
              <li>Long-term normalization using reanalysis datasets</li>
              <li>Operational benchmarking across sites and turbine models</li>
              <li>Grid interface overview and restoration CAPEX estimation</li>
            </ul>

            <p><strong>Outcome:</strong></p>
            <ul>
              <li>Consolidated P75/P90 portfolio metrics</li>
              <li>
                Identification of underperforming sites and reliability risks
              </li>
              <li>Investment prioritization and refurbishment roadmap</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        {/* Engagement 1 (NOW THIRD) */}
        <AccordionItem id="eng1">
          <span
            onClick={() => onSelect(2)}
            style={{ display: "block", cursor: "pointer" }}
          >
            <AccordionTitle id="eng1">
              Independent Technical Due Diligence for Operating Wind Assets
            </AccordionTitle>
          </span>

          <AccordionContent id="eng1">
            <p><strong>Location:</strong> Gujarat</p>
            <p>
              <strong>Client Type:</strong> Indian IPP / Sponsor-backed platform
            </p>
            <p><strong>Portfolio:</strong> ~65 MW operating wind assets (32 WTGs)</p>
            <p>
              <strong>Role:</strong> Independent Technical Advisor / TDD
              Consultant
            </p>

            <p><strong>Scope:</strong></p>
            <ul>
              <li>
                Finance-grade resource & energy yield assessment (WRF–CFD,
                P50/P75/P90)
              </li>
              <li>SCADA & generation reconciliation and OEYA-style analysis</li>
              <li>
                Technical condition screening, grid evacuation review, ROM CAPEX
              </li>
              <li>
                Identification of red flags and WTGs for site verification
              </li>
            </ul>

            <p><strong>Outcome:</strong></p>
            <ul>
              <li>Lender-ready TDD / TEV report</li>
              <li>Energy yield sensitivities and risk register</li>
              <li>Inputs used for investment and refinancing evaluation</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        {/* Engagement 3 (NOW FOURTH) */}
        <AccordionItem id="eng3">
          <span
            onClick={() => onSelect(3)}
            style={{ display: "block", cursor: "pointer" }}
          >
            <AccordionTitle id="eng3">
              Lender-Support Technical Review for Operating Wind Assets
            </AccordionTitle>
          </span>

          <AccordionContent id="eng3">
            <p><strong>Location:</strong> Multi-site, India</p>
            <p>
              <strong>Client Type:</strong> Domestic lender / credit committee
            </p>
            <p><strong>Portfolio:</strong> Operating wind assets</p>
            <p>
              <strong>Role:</strong> Independent Engineer-style Technical
              Reviewer
            </p>

            <p><strong>Scope:</strong></p>
            <ul>
              <li>Document & VDR review (SCADA, O&M, grid, warranties)</li>
              <li>
                Validation of sponsor energy assumptions and downside cases
              </li>
              <li>Technical risk register and mitigation framework</li>
              <li>Management and lender Q&A support</li>
            </ul>

            <p><strong>Outcome:</strong></p>
            <ul>
              <li>Finance-grade technical memo and draft/final reports</li>
              <li>
                Support to lender credit approval and conditions precedent
              </li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        {/* Engagement 4 (NOW FIFTH) */}
        <AccordionItem id="eng4">
          <span
            onClick={() => onSelect(4)}
            style={{ display: "block", cursor: "pointer" }}
          >
            <AccordionTitle id="eng4">
              Hybrid / RTC System Modeling with Rolling Generation Forecast
            </AccordionTitle>
          </span>

          <AccordionContent id="eng4">
            <p><strong>Location:</strong> Rajasthan</p>
            <p>
              <strong>Client Type:</strong> Independent Power Producer (IPP)
            </p>
            <p>
              <strong>Project Concept:</strong> Co-located wind and solar
              development on a common land parcel
            </p>
            <p>
              <strong>Role:</strong> Hybrid System Modeling & Forecasting
              Advisor
            </p>

            <p><strong>Scope:</strong></p>
            <ul>
              <li>
                Integrated hybrid system modeling for combined wind–solar
                configuration
              </li>
              <li>
                Site-specific wind and solar resource assessment and energy
                simulation
              </li>
              <li>
                Six-month rolling generation forecast to capture seasonal
                variability
              </li>
              <li>
                Analysis of generation profiles to support phasing and sizing
                decisions
              </li>
              <li>
                Inputs for grid planning, evacuation strategy, and development
                readiness
              </li>
            </ul>

            <p><strong>Outcome:</strong></p>
            <ul>
              <li>
                Forward-looking energy generation outlook for near-term
                development planning
              </li>
              <li>
                Optimized hybrid configuration aligned with expected resource
                availability
              </li>
              <li>
                Forecast-driven insights supporting project staging and
                investment timing
              </li>
            </ul>
          </AccordionContent>
        </AccordionItem>

      </Accordion>
    </div>
  );
};

export default AccordionWrap;